import { render, staticRenderFns } from "./DocActions.vue?vue&type=template&id=21af5581&scoped=true&lang=pug&"
import script from "./DocActions.vue?vue&type=script&lang=js&"
export * from "./DocActions.vue?vue&type=script&lang=js&"
import style0 from "./DocActions.vue?vue&type=style&index=0&id=21af5581&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af5581",
  null
  
)

export default component.exports